import "virtual:node-globals";
import React from "react";
import { createRoot } from "react-dom/client";
import { initHttpProvider } from "@redbelly-tokeniser/mystake-api-sdk";
import { App } from "./App";
import { stashInviteFromAddress } from "./components/pages/AvererInvite/inviteStash";
// Tokeniser Design System global tokens (fonts → colours → type → spacing → effects → base).
// Components reference these semantic CSS custom properties; legacy aliases still resolve.
import "./designSystem/styles.css";

// Initialize HTTP provider with Vite environment variables
initHttpProvider({
  baseUrl:
    import.meta.env.VITE_LOCALHOST === "true" ? "http://localhost:4000" : import.meta.env.VITE_API_BASE_URL || "/api",
  webBaseUrl: import.meta.env.VITE_WEB_BASE_URL || window.location.origin,
});

const container = document.getElementById("root");
if (!container) {
  throw new Error("Failed to find the root element");
}

stashInviteFromAddress();
const root = createRoot(container);
root.render(<App />);
